import React, {Component} from 'react';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import './App.css';
import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider';
import createMuiTheme from '@material-ui/core/styles/createMuiTheme';
import jwtDecode from 'jwt-decode';
// Redux
import {Provider} from 'react-redux';
import store from './redux/store';
import {SET_AUTHENTICATED} from './redux/types';
import {logoutUser, getUserData} from './redux/actions/userActions';
// Components
import Navbar from './components/layout/Navbar';
import themeObject from './util/theme';
import AuthRoute from './util/AuthRoute';
import FooterPage from './components/layout/FooterPage';
// Pages
import home from './pages/home';
import login from './pages/login';
import signup from './pages/signup';
import user from './pages/user';
import landing from './pages/landing';
import about from './pages/about';
import contact from './pages/contact';
import account from './pages/account';
//Axios
import axios from 'axios';

const theme = createMuiTheme(themeObject);

axios.defaults.baseURL =
  'https://europe-west1-socialapp-c26ee.cloudfunctions.net/api';

const token = localStorage.FBIdToken;
if (token) {
  const decodedToken = jwtDecode(token);
  if (decodedToken.exp * 1000 < Date.now()) {
    store.dispatch(logoutUser());
    window.location.href = '/login';
  } else {
    store.dispatch({type: SET_AUTHENTICATED});
    axios.defaults.headers.common['Authorization'] = token;
    store.dispatch(getUserData());
  }
}

class App extends Component {
  render() {
    return (
      <MuiThemeProvider theme={theme}>
        <Provider store={store}>
          <Router>
            <Navbar />
            <Route exact path='/' component={landing} />
            <div className='container'>
              <Switch>
                <Route exact path='/home' component={home} />
                <Route exact path='/about' component={about} />
                <Route exact path='/contact' component={contact} />
                <Route exact path='/account' component={account} />
                <AuthRoute exact path='/login' component={login} />
                <AuthRoute exact path='/signup' component={signup} />
                <Route exact path='/users/:handle' component={user} />

                <Route
                  exact
                  path='/users/:handle/scream/:screamId'
                  component={user}
                />
              </Switch>
            </div>
          </Router>
        </Provider>
        <FooterPage />
      </MuiThemeProvider>
    );
  }
}

export default App;

// build a web traffic monitor:
// https://scotch.io/tutorials/build-a-web-traffic-monitor-with-python
// https://duckduckgo.com/?q=python+network+traffic&t=lm&atb=v178-1&ia=web
